import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import { Dispatch } from "redux";

interface RequestSumarizationModel {
    idSolicitation: number;
    idUser: number
    recordType: number;
    conclusionText?: string
}
export interface NewSumaryParams {
    solicitationId: number;
    IdUser: number;
    recordType: number;
    numberOfComments: number;
    conclusionText?: string;
    summary?: boolean;
}
    export const setNewSummary = async (SolicitationParams: NewSumaryParams, dispatch:Dispatch, props: any  ) => {
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    try {
        var solicitationSumarizeRequest: RequestSumarizationModel = {
            idSolicitation:SolicitationParams.solicitationId,
            idUser: SolicitationParams.IdUser,
            recordType: SolicitationParams.recordType,
        }
        if (SolicitationParams.conclusionText) {
            solicitationSumarizeRequest = { ...solicitationSumarizeRequest, conclusionText: SolicitationParams.conclusionText };
        }
        let response = await generativeIaEvaluationService.SetCommentSummary(solicitationSumarizeRequest)
        dispatch({
            type: 'ShowNotification',
            payload: {
                visible: false,
                idSolicitation: props.solicitation.id,
                sumarization: SolicitationParams.summary
            }
        });
        return response;
        
    }
    catch (error) {
        console.error(error)
        return error;
    }
}